import React from 'react';
import styles from './ProfileTabButtons.module.css';
import { Briefcase, Globe, Review } from '../../../../assets/images/icons';
import { useTranslation } from 'react-i18next';

function ProfileTabButtons({ blur, isEmployer, activeTab, setActiveTab }) {
  const { t } = useTranslation();

  const handleScroll = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className={`${blur && styles.blur} ${styles.container}`} >
      {isEmployer ?
        <>
          <button
            className={styles.button}
            style={{
              color: activeTab !== 'aboutOurCompany' ? 'black' : '#0464B2',
            }}
            onClick={() => {
              setActiveTab('aboutOurCompany');
              handleScroll('aboutMe');
            }}
          >
            <img
              src={Globe}
              alt="World Icon"
              className={styles.icon}
              style={{
                filter: activeTab === 'aboutOurCompany' ? 'invert(34%) sepia(75%) saturate(2677%) hue-rotate(187deg) brightness(96%) contrast(99%)' : 'none',
              }}
            />
            {t('AboutCompany.title')}
          </button>
          <button
            className={styles.button}
            style={{
              color: activeTab !== 'jobs' ? 'black' : '#0464B2',
            }}
            onClick={() => {
              setActiveTab('jobs');
              // handleScroll('workExperience');
            }}
          >
            <img
              src={Briefcase}
              alt="Education Icon"
              className={styles.icon}
              style={{
                filter: activeTab === 'jobs' ? 'invert(34%) sepia(75%) saturate(2677%) hue-rotate(187deg) brightness(96%) contrast(99%)' : 'none',
              }}
            />
            {t('defaultFooter.jobs')}
          </button>
          <button
            className={styles.button}
            style={{
              color: activeTab !== 'review' ? 'black' : '#0464B2',
            }}
            onClick={() => {
              setActiveTab('review');
              handleScroll('workExperience');
            }}
          >
            <img
              src={Review}
              alt="Work Experience Icon"
              className={styles.icon}
              style={{
                filter: activeTab === 'review' ? 'invert(34%) sepia(75%) saturate(2677%) hue-rotate(187deg) brightness(96%) contrast(99%)' : 'none',
              }}
            />
            {t('defaultFooter.reviews')}
          </button>


        </>
        :
        <>

          <button className={styles.button} onClick={() => handleScroll('aboutMe')}>
            <img src={Globe} alt="World Icon" className={styles.icon} />
            {t('profile_tabs.about')}
          </button>
          <button className={styles.button} onClick={() => handleScroll('education')}>
            <img src={Globe} alt="Education Icon" className={styles.icon} />
            {t('profile_tabs.education')}
          </button>
          <button className={styles.button} onClick={() => handleScroll('workExperience')}>
            <img src={Globe} alt="Work Experience Icon" className={styles.icon} />
            {t('profile_tabs.work_experience')}
          </button>
          <button className={styles.button} onClick={() => handleScroll('skills')}>
            <img src={Globe} alt="Skills Icon" className={styles.icon} />
            {t('profile_tabs.skills')}
          </button>
          <button className={styles.button} onClick={() => handleScroll('certifications')}>
            <img src={Globe} alt="Certifications Icon" className={styles.icon} />
            {t('profile_tabs.certifications')}
          </button>
          <button className={styles.button} onClick={() => handleScroll('portfolio')}>
            <img src={Globe} alt="Portfolio Icon" className={styles.icon} />
            {t('profile_tabs.portfolio')}
          </button>
          {/* <button className={styles.button} onClick={() => handleScroll('workProficiency')}>
                        <img src={Globe} alt="Work Proficiency Icon" className={styles.icon} />
                        {t('profile_tabs.work_proficiency_test')}
                    </button> */}
        </>
      }
    </div>
  );
}

export default ProfileTabButtons;
